import { render, staticRenderFns } from "./ProductLoft.vue?vue&type=template&id=56e1d75f&scoped=true&"
import script from "./ProductLoft.vue?vue&type=script&lang=js&"
export * from "./ProductLoft.vue?vue&type=script&lang=js&"
import style0 from "./ProductLoft.vue?vue&type=style&index=0&id=56e1d75f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e1d75f",
  null
  
)

export default component.exports